import { Injectable, Injector } from "@angular/core";
import { ApiService } from "../base-service/api.service";
import { HttpClient } from "@angular/common/http";
import { Http } from "@angular/http";
import { Subject } from 'rxjs';

@Injectable()
export class WebNotificationService extends ApiService<any, any, any> {
    unreadCountSubject: Subject<any> = new Subject();

    urlPath: string = 'notifications';

    constructor(private Http: HttpClient, Injector: Injector, private http: Http) {
        super(Http, Injector);
    }
}
